<template>
    <SiteNavbar :empresa="logo"/>
  <TableEventos :empresa="empresa" :telefone="telefone" />
</template>

<script>
import TableEventos from '@/components/TableEventos.vue';
import SiteNavbar from '@/components/SiteNavbar.vue'
export default {
  name: 'CemiterioPrevida',
  components: {
    TableEventos, SiteNavbar
  },
  data() {
    return {
      empresa: "Cemiterio Previda",
      logo: "cemiterioprevida",
      telefone: "0800 082 9000"
    };
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
